import { render } from "./AboutUsSliderOne.vue?vue&type=template&id=d8383ad4&scoped=true"
import script from "./AboutUsSliderOne.vue?vue&type=script&lang=js"
export * from "./AboutUsSliderOne.vue?vue&type=script&lang=js"

import "./AboutUsSliderOne.vue?vue&type=style&index=0&id=d8383ad4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d8383ad4"

export default script